import type { CpmReportCampaignQuery, CpmReportSubmissionsQuery } from '@/generated/cpm-report';

export type ReportCampaign = NonNullable<CpmReportCampaignQuery['adminCpmCampaign']>;
export type ReportSubmission = CpmReportSubmissionsQuery['adminCpmCampaignSubmissions']['data'][number];
export type ReportSnapshot = {
  campaign: ReportCampaign;
  submissions: ReportSubmission[];
  collectionStartedAt: string;
  collectionFinishedAt: string;
};

export class CampaignReportError extends Error {
  constructor(public readonly code: 'invalid' | 'inconsistent' | 'load' | 'ai_unavailable' | 'ai_busy' | 'ai_failed') {
    super(code);
    this.name = 'CampaignReportError';
  }
}
